export const INSTRUCTIONS = "INSTRUCTIONS";
export const PRESENTATION = "PRESENTATION";

const STEPS = [INSTRUCTIONS, PRESENTATION];

export default STEPS;
